module.exports = __webpack_public_path__ + "media/images/shop/logo-doki-3039b4122a41705b0682732af27fe313.png";